import templateUrl from 'emun.customer/customer-container-full.htm'
import basicController from 'servicestack/basic.controller.properties'
import AutoQuery from 'servicestack/auto-query/auto-query'

class CustomerContainerController  {
    constructor($scope) {
        //constructor($scope, NgMap) {
            const $ctrl = this;
        basicController($ctrl);
        //$ctrl.map = {
        //    zoom: 12,
        //    center: '35806 USA',
        //    store: null
        //};
        
        //NgMap.getMap().then(function(map) {
        //    map.$ctrl = $ctrl;
        //    $ctrl.map.instance = map;
        //});
    }
    $onInit(){
        const $ctrl = this;
        let options = {
            url: 'QueryRetailersJoin.json',
            fields:
                "Id,CompanyName,Address,City,State,Zip,Email,Phone,Status,SalesRepName",
            pageSize: $ctrl.$pageConfig.is('gt-sm') ? 12 : 6,
            views: {
                'list': 'th-list',
                'cards':'th'
                //'map': 'map'
            },
            criteria: {
                status: 'Active'
            },
            view: $ctrl.$pageConfig.is('gt-md') ? 'list' : 'cards',
            filters: [
                {groupBy:'Status'},
                {date:'LastOrderedOn',title:'Last Order Date'},
                {date:'CreatedOn',title:'Created Date',collapsed:true},
                //{groupBy:'City',maxHeight:200,collapsed:true},
                {groupBy:'State',maxHeight:200,collapsed:true},
                //{groupBy:'SalesRepName',title:'Rep',maxHeight:200,collapsed:true},
                {groupBy:'AccountType',title:'Account Type',maxHeight:200,collapsed:true}
                //{groupBy:'TerritoryName',title:'Territory',maxHeight:200,collapsed:true},
                //{groupBy:'RegionName',title:'Region',maxHeight:200,collapsed:true}
            ],
            hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
            orderBy: 'Status,CompanyName,Id',
            autoLoad: true,
            append: false,
            sortOptions: {
                'Id': 'Id',
                '-Id': 'Id',
                'CompanyName,Id': 'Name',
                '-CompanyName,Id': 'Name',
                'City,Id': 'City',
                '-City,Id': 'City',
                'State,Id': 'State',
                '-State,Id': 'State',
                'Zip,Id': 'Zip',
                '-Zip,Id': 'Zip',
                'SalesRepName,Id': 'Rep',
                '-SalesRepName,Id': 'Rep',
                'TerritoryName,Id': 'Territory',
                '-TerritoryName,Id': 'Territory',
                'RegionName,Id': 'Region',
                '-RegionName,Id': 'Region',
                'Status,CompanyName,Id': 'Status',
                '-Status,CompanyName,Id': 'Status'
            }
        };
        $ctrl.query = new AutoQuery(options);
    }
    load(){
        const $ctrl = this;
        return $ctrl.query.load.apply($ctrl.query, arguments);
    }
}

export default CustomerContainerController